module.exports = __webpack_public_path__ + "static/media/light_ru.b2482392.svg";